import React, { useEffect, useState } from 'react';
import {
    getLocalStorageMenuItem,
    getOrderBadgeStatusClass,
    SARIconThemeColor,
    setMobileBackColor,
    setMobileCardBorderColor,
    setMobileCardColor,
    setMobileTextColor,
    setMobileTextField_BK_FONT_Border_StyleColor,
} from "../utility";
import { Badge, Container, Navbar, Modal } from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";
import coverSample from "../images/No_Image_Available.jpg";
import no_image from "../images/No_Image_Available.jpg";
import axios from "axios";
import { useQuery } from "react-query";
import "../css/mobileScreens.css";
import Loading from "../common/loading";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, IconButton } from "@mui/material";
import { ArrowBackOutlined, ReceiptOutlined, LocationOn, CancelOutlined } from "@mui/icons-material";
import { t } from "i18next";
import no_archive from "../images/no_archive.png";
import ErrorDialog from "../common/errorDialog";
import BottomNavBar from "../components/BottomNavBar";
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';

const Transactions = () => {
    const queryString = window.location.search;
    const urlParam = new URLSearchParams(queryString);
    const { qrName, qrCode } = useParams();
    const navigate = useNavigate();
    const lang = getLocalStorageMenuItem("lang");

    const [toastSettings, setToastSettings] = useState({
        open: false,
        message: "",
        success: false,
    });
    const [detailsData] = useState(getLocalStorageMenuItem("tree_data")?.details || []);
    const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
    const [isTablet, setIsTablet] = useState(window.innerWidth >= 768 && window.innerWidth < 1024);
    const [isDesktop, setIsDesktop] = useState(window.innerWidth >= 1024);

    // Add this useEffect for responsive detection
    useEffect(() => {
        const handleResize = () => {
            const width = window.innerWidth;
            setIsMobile(width < 768);
            setIsTablet(width >= 768 && width < 1024);
            setIsDesktop(width >= 1024);
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const { data: TransactionsData, isLoading: TransactionsIsLoading, isError: TransactionsIsError } = useQuery("transactions", async () => {
        const timeZone = getLocalStorageMenuItem("timezone") ? getLocalStorageMenuItem("timezone") : "";
        const MobileToken = getLocalStorageMenuItem("mobileLoginToken");
        return await axios.get(
            `${process.env.REACT_APP_API}/customer/wallet-transactions?token=${getLocalStorageMenuItem("mobileLoginToken")}`,
            { headers: { localization: lang, Authorization: `Bearer ${MobileToken}`, timeZone: timeZone.replace(/["]+/g, '') } }
        );
    });



    const handleOpenToast = (message, state) => {
        setToastSettings({
            open: true,
            success: state,
            message: message
        });
    };

    const handleCloseToast = (event, reason) => {
        if (reason === "clickaway") return;
        setToastSettings({ open: false, message: "", success: false });
    };

    const handleBack = () => {
        navigate(
            `/${qrName}/${qrCode}/sections?section=${urlParam.get("section")}&t=${urlParam.get("t")}&lang=${getLocalStorageMenuItem("lang")}`
        );
    };



    const onImageError = (e) => {
        e.target.src = coverSample;
    };

    if (TransactionsIsLoading) {
        return <Loading backColor={setMobileBackColor()} />;
    }

    if (TransactionsIsError) {
        return <ErrorDialog />;
    }

    return (
        <div className={`min-vh-100`} style={{ backgroundColor: setMobileBackColor() }}>
            <Container fluid>
                <div className="row">
                    <div className={`${isDesktop ? '' : 'col-lg-4'} ms-auto p-0`}>
                        <div className={`${isDesktop ? 'container' : ''} mobile-side-screen`}>
                            <Navbar
                                className={`d-flex justify-content-between align-items-center position-fixed top-0 z-2 mobile-nav`}
                                style={{
                                    width: "100%",
                                    margin: "auto",
                                    backgroundColor: setMobileCardColor(),
                                }}
                            >
                                <Button
                                    onClick={handleBack}
                                    style={{ color: setMobileTextColor() }}
                                >
                                    <ArrowBackOutlined sx={{ color: setMobileTextColor() }} />
                                </Button>

                                <Navbar.Brand className="text-center m-0">
                                    <p
                                        className="mb-1 text-center sub-font"
                                        style={{ color: setMobileTextColor() }}
                                    >
                                        {detailsData?.table}
                                    </p>
                                </Navbar.Brand>
                            </Navbar>

                            <div
                                className="mx-2 mb-4 alignByLang"
                                style={{ marginTop: "45px" }}
                            >
                                <Box className="head-font" sx={{ textAlign: "center", padding: 2, color: setMobileTextColor() }}>{t("Your Balance")} : {getLocalStorageMenuItem("customer_balance")}</Box>
                                {TransactionsData?.data.data?.transactions.length > 0 ? (
                                    TransactionsData?.data.data?.transactions.map((transaction) => (
                                        <Card
                                            key={transaction.transaction_id}
                                            sx={{
                                                mb: 2,
                                                backgroundColor: setMobileBackColor(),
                                                border: `1px solid ${setMobileCardBorderColor()}`,
                                                borderRadius: '12px',
                                                cursor: 'pointer',
                                                '&:hover': {
                                                    boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)'
                                                }
                                            }}
                                        >
                                            <CardContent>
                                                <Box sx={{
                                                    display: "flex",
                                                    flexDirection: "row",
                                                    justifyContent: "space-between",
                                                    alignItems: 'center',
                                                    mb: 2
                                                }}>
                                                    <Typography
                                                        className="head-font"
                                                        variant="h6"
                                                        sx={{
                                                            color: setMobileTextColor(),
                                                            fontWeight: 'bold',
                                                            display: 'flex',
                                                            alignItems: 'center'
                                                        }}
                                                    >
                                                        <ReceiptOutlined
                                                            sx={{ color: setMobileTextColor(), mr: 1 }}
                                                            fontSize="medium"
                                                        />
                                                        {t("Transaction details")}
                                                    </Typography>

                                                    <Badge
                                                        className={` ${getOrderBadgeStatusClass(
                                                            transaction.status
                                                        )} p-2 font-size-12 sub-font`}
                                                        sx={{
                                                            borderRadius: '12px',
                                                            fontSize: '0.75rem'
                                                        }}
                                                    >
                                                        {t(transaction.type) || ""}
                                                    </Badge>
                                                </Box>

                                                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>

                                                    <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                                                        <Typography className="sub-font" variant="body2" sx={{ color: setMobileTextColor() }}>
                                                            {t("Transaction Time")} :
                                                        </Typography>
                                                        <Typography className="sub-font" variant="body2" sx={{ color: setMobileTextColor(), fontWeight: 'bold' }}>
                                                            {transaction.created_at}
                                                        </Typography>
                                                    </Box>

                                                    <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                                                        <Typography className="sub-font" variant="body2" sx={{ color: setMobileTextColor() }}>
                                                            {t("Reason")} :
                                                        </Typography>
                                                        <Typography className="sub-font" variant="body2" sx={{ color: setMobileTextColor(), fontWeight: 'bold' }}>
                                                            {transaction.reason}
                                                        </Typography>
                                                    </Box>

                                                    <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                                                        <Typography className="sub-font" variant="body2" sx={{ color: setMobileTextColor() }}>
                                                            {t("Amount")} :
                                                        </Typography>
                                                        <Typography className="sub-font" variant="body2" sx={{ color: setMobileTextColor(), fontWeight: 'bold' }}>
                                                            {transaction.amount} {detailsData?.currency_symbol ? detailsData?.currency_symbol === "SAR" ? <img width={20} height={20} src={SARIconThemeColor()} className="mr-1" /> : detailsData?.currency_symbol : ""}
                                                        </Typography>
                                                    </Box>
                                                </Box>

                                            </CardContent>
                                        </Card>
                                    ))
                                ) : (
                                    <Box
                                        sx={{
                                            display: 'flex',
                                            flexDirection: 'column',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            minHeight: '70vh',
                                            backgroundColor: setMobileCardColor(),
                                            p: 3,
                                            borderRadius: '12px'
                                        }}
                                    >
                                        <Box sx={{ width: 150, height: 150, mb: 3 }}>
                                            <img src={no_archive} alt="Not Found" style={{ width: '100%', height: '100%', objectFit: 'contain' }} />
                                        </Box>
                                        <Typography className="head-font" variant="h6" sx={{
                                            fontWeight: 'bold',
                                            color: setMobileTextColor(),
                                            textAlign: 'center'
                                        }}>
                                            {t("There are no transactions")}
                                        </Typography>
                                    </Box>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </Container>



            <BottomNavBar qr={qrCode} qrName={qrName} />
        </div>
    );
};

export default Transactions;